import React from 'react';
import type { AssetAnalysisData } from '../types';

interface AssetOverviewCardProps {
  analysis: AssetAnalysisData;
  formatAmount: (amount: number) => string;
  formatReturnRate: (rate: number) => string;
}

/**
 * 资产概览卡片组件
 */
export const AssetOverviewCard: React.FC<AssetOverviewCardProps> = ({
  analysis,
  formatAmount,
  formatReturnRate
}) => {
  return (
    <div className="mb-6 grid grid-cols-3 gap-2">
      <div className="rounded-lg bg-gradient-to-br from-[#EEEDFF] to-[#F6F7FF] p-4">
        <div className="text-sm font-semibold text-[#1F1F1F]">总资产</div>
        <div className="text-xl font-semibold text-[#1F1F1F]">
          {formatAmount(analysis.totalAssets)}
        </div>
      </div>
      <div className="rounded-lg bg-gradient-to-br from-[#EEEDFF] to-[#F6F7FF] p-4">
        <div className="text-sm font-semibold text-[#1F1F1F]">总盈亏</div>
        <div className="text-xl font-semibold text-[#1F1F1F]">
          {formatAmount(analysis.totalProfitLoss)}
        </div>
      </div>
      <div className="rounded-lg bg-gradient-to-br from-[#EEEDFF] to-[#F6F7FF] p-4">
        <div className="text-sm font-semibold text-[#1F1F1F]">总收益率</div>
        <div
          className={`text-xl font-semibold ${analysis.totalReturnRate >= 0 ? 'text-red-600' : 'text-green-600'}`}
        >
          {formatReturnRate(analysis.totalReturnRate)}
        </div>
      </div>
    </div>
  );
};
